module.exports = __webpack_public_path__ + "static/media/hest-live.ad372708.png";